//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ControlPoint",1,"Point",0],[1,"CopySelectInsert",0,"SelectBodyList",0],[0,"DestinationPoint",1,"Point",0],[1,"InsertsToDelete",0,"SelectBodyList",0],[1,"ReparentSelectInsert",0,"Assemblies.SelectComponentList",0],[1,"ShanksToDelete",0,"ScCollector",0],[0,"Type",1,0],[0,"UpdateExpressionWithoutParentChange",1,0]],[[["componentName","parentName"],"ReparentComponent",{},2,0],[["insertNum","insertTags"],"GetAllNeedReparentInsertGroups",{},0,0],[["insertTag"],"AskNewParentNameOfInsert",{R_:{parentName:''}},1,0]],[]];
SPLM.Tooling.InsertEditToolsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.InsertEditToolsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.InsertEditToolsBuilder.Types = Object.freeze({
    "Copy" : "Copy", "Delete" : "Delete", "ChangeParent" : "ChangeParent", "UpdateAllInsertPosition" : "UpdateAllInsertPosition"});

export default SPLM;